import { Check, WclImg } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../routes/type";
import { useTranslation } from "react-i18next";
import FAQs from "./FAQs";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { MdFullscreen } from "react-icons/md";
import { IoCloseSharp } from "react-icons/io5";

function Home() {
  const navigate = useNavigate();
  const handleFindClaim = () => {
    navigate(RouteNames.SELECT_SEARCH_METHOD);
  };
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const videoRef = useRef(null);

  const fullscreen = () => {
    if (!document.fullscreenElement) {
      videoRef.current.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };
  const faqs = [
    {
      question: "What do I need to file a claim?",
      answerListOut: [
        "Invoice Handy: Ensure you have your invoice ready.",
        "Picture Verbiage: Be prepared to submit pictures of the item you're filing a claim on.",
      ],
    },
    {
      question: "How long will it take for ProtectALL to review my claim?",
      answer: "Claims are typically reviewed within 3 to 5 business days.",
    },
    {
      question: "What if I do not see the item I am looking for?",
      answer: "Submit your invoice and additional details for review.",
    },
    {
      question: "What if I do not have my invoice?",
      answer: "Contact your selling retailer to obtain a copy.",
    },
  ];

  return (
    <div className="">
      <div className="bg-blue-light text-center p-4  flex items-end justify-center hero-banner">
        <img src={WclImg} alt="Welcome" className="mx-auto" />
      </div>
      <div className="sm:mt-12 mt-8">
        <h3 className="font-semibold sm:text-3xl text-[22px] sm:px-10 px-4 text-center">
          {t("Welcome to the MyProtectAll Unified Claim Request System")}
        </h3>
        <ul className="min-[400px]:text-lg flex flex-col gap-y-3 mx-auto px-6 w-fit mt-8">
          <li className="flex items-center gap-3">
            <img src={Check} alt="MyProtectAll" />
            <span>{t("Find Warranty")}</span>
          </li>
          <li className="flex items-center gap-3">
            <img src={Check} alt="MyProtectAll" />
            <span>{t("Select Product")}</span>
          </li>
          <li className="flex items-center gap-3">
            <img src={Check} alt="MyProtectAll" />
            <span>{t("Provide claim information")}</span>
          </li>
          <li className="flex items-center gap-3">
            <img src={Check} alt="MyProtectAll" />
            <span>{t("Submit")}</span>
          </li>
        </ul>
      </div>
      <div className="text-center sm:mt-10 mt-8 mb-6 grid gap-4 justify-center">
        <button
          type="button"
          aria-label="button"
          onClick={handleFindClaim}
          className="p-2 rounded-full text-center bg-brand-color h-[50px] w-[247px] text-white hover:brand-hover"
        >
          {t("Start")}!
        </button>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-[999]"
            onClose={() => setIsOpen(false)}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black/25 " />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden flex items-center justify-center">
              <div className="flex h-full items-center justify-center p-4 text-center overflow-hidden max-w-[1440px]">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-auto z-[9999] transform overflow-hidden rounded-2xl bg-white p-4 text-left align-middle shadow-xl transition-all flex flex-col h-auto max-h-full">
                    <div className="flex items-center justify-between mb-3">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium leading-6 text-gray-900"
                      >
                        Claim Video Tutorial
                      </Dialog.Title>
                      <button onClick={() => setIsOpen(false)}>
                        <IoCloseSharp className="size-6" />
                      </button>
                    </div>
                    <video
                      ref={videoRef}
                      controls
                      autoPlay
                      className="h-auto max-h-full overflow-hidden block"
                      // src="https://gbspublicassets.s3.amazonaws.com/training_materials/Claim_Request_Walk_Through-2025-02-02.mp4"
                      src="https://gbspublicassets.s3.amazonaws.com/training_materials/Claim_Request_Walk_Through.mp4"
                    ></video>

                    <button
                      onClick={fullscreen}
                      className="sm:hidden flex mt-4 items-center justify-center mx-auto gap-2 p-2 rounded-full text-center bg-brand-color h-[40px] w-[247px] text-white hover:brand-hover"
                    >
                      <MdFullscreen className="size-6" />
                      <span>View in fullscreen</span>
                    </button>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
      <div className="mb-10">
        <h3 className="font-semibold text-xl px-4 text-center">
          {t("Filing a Claim with ProtectALL")}
        </h3>
        <div className="px-4 mt-3">
          {faqs.map((item, index) => (
            <FAQs item={item} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
